// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11da5fe0","455":"04d199c4","977":"d18a8296"}[chunkId] + ".chunk.js";
};